// extracted by mini-css-extract-plugin
export default {"item":"SubjectList_item__mHKkh"};